// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__27CwD","clinicsSelect":"TableHeading_clinicsSelect__2z3u0"};